import React from 'react'
import { _ } from 'utils'
import { categoriesQuery, tagsQuery } from '../graphql/query'
import {
    createMovieCategory,
    createMovieTag,
    deleteMovieTagCategory,
    deleteMovieTag,
    updateMovieCategoryOrder, updateMovieCategory,
    updateMovieTag,
    updateMovieTagOrder
} from '../graphql/mutation'
import TagsPage from '../../tags/TagsPage'

const MovieTags = () => (
    <TagsPage
        description={_('movie.manage_tags.description')}
        tagKey="movieTags"
        categoryKey="movieTagCategories"
        tagsQuery={tagsQuery}
        categoriesQuery={categoriesQuery}
        updateTagOrder={updateMovieTagOrder}
        updateCategoryOrder={updateMovieCategoryOrder}
        deleteCategory={deleteMovieTagCategory}
        deleteTag={deleteMovieTag}
        updateTag={updateMovieTag}
        createTag={createMovieTag}
        createCategory={createMovieCategory}
        updateCategory={updateMovieCategory}
    />
)

export default MovieTags
